import { CircularProgress, SxProps } from "@mui/material";
import {
  MouseEvent,
  MouseEventHandler,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { AccessRightChecks } from "../../../../features/user/accessRightChecks";
import { CustomButton } from "../customButton/CustomButton";

export type Props = {
  label: string;
  variant?: "contained" | "outlined" | "text";
  disabled?: boolean;
  isLoading?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps;
  spinnerSx?: SxProps;
  color: "primary" | "secondary" | "error" | "info" | "success" | "warning";
  spinnerSize?: number;
  startIcon?: ReactNode;
  accessRightChecks?: AccessRightChecks;
};

export const SpinnerButton = ({
  label,
  variant = "outlined",
  isLoading,
  disabled,
  onClick,
  sx,
  spinnerSx,
  color,
  spinnerSize = 24,
  startIcon,
  accessRightChecks,
}: Props) => {
  const [waitForFinish, setWaitForFinish] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur();
    if (isLoading !== undefined) {
      setTimeout(() => {
        setWaitForFinish(true);
      }, 50);
    }
    onClick(event);
  };

  useEffect(() => {
    if (waitForFinish && isLoading !== undefined && !isLoading) {
      setWaitForFinish(false);
    }
  }, [isLoading, waitForFinish]);

  return (
    <CustomButton
      startIcon={startIcon}
      sx={{
        height: "30px",
        textTransform: "none",
        borderRadius: "15px",
        fontWeight: "700",
        ...sx,
      }}
      disabled={disabled || waitForFinish}
      variant={variant}
      onClick={handleClick}
      color={color}
      accessRightChecks={accessRightChecks}
    >
      {isLoading !== undefined && waitForFinish ? (
        <CircularProgress
          size={spinnerSize}
          sx={{
            margin: "0px 16px",
            color: "white",
            ...spinnerSx,
          }}
        />
      ) : (
        label
      )}
    </CustomButton>
  );
};
